/// <reference types="./folder.d.mts" />
import * as $svg from "../../ds/internals/svg.mjs";

export function folder() {
  return $svg.square(
    16,
    "<path d=\"M2.66671 3.33333V12.6667H13.3334V4.66667H7.72404L6.39071 3.33333H2.66671ZM8.27604 3.33333H14C14.1769 3.33333 14.3464 3.40357 14.4714 3.5286C14.5965 3.65362 14.6667 3.82319 14.6667 4V13.3333C14.6667 13.5101 14.5965 13.6797 14.4714 13.8047C14.3464 13.9298 14.1769 14 14 14H2.00004C1.82323 14 1.65366 13.9298 1.52864 13.8047C1.40361 13.6797 1.33337 13.5101 1.33337 13.3333V2.66667C1.33337 2.48986 1.40361 2.32029 1.52864 2.19526C1.65366 2.07024 1.82323 2 2.00004 2H6.94271L8.27604 3.33333Z\" fill=\"currentColor\"/>",
  );
}
